import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { getData } from 'features/dinamic';

interface FacilitadorGrupoState {
  statusActivos: string;
  statusFinalizados: string;
  error: string;
  gruposActivos: any[];
  gruposFinalizados: any[];
}

const initialState: FacilitadorGrupoState = {
  statusActivos: 'idle',
  statusFinalizados: 'idle',
  error: '',
  gruposActivos: [],
  gruposFinalizados: [],
};

export const fetchMisGruposActivos = createAsyncThunk(
  'facilitador/fetchMisGruposActivos',
  async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 142;
    const { result, message, data } = await getData({ idsp, estadoCiclo: 1 }, getState, dispatch);
    if (result) {
      return { data };
    }
    return rejectWithValue(message);
  }
);

export const fetchMisGruposFinalizados = createAsyncThunk(
  'facilitador/fetchMisGruposFinalizados',
  async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 142;
    const { result, message, data } = await getData({ idsp, estadoCiclo: 0 }, getState, dispatch);
    if (result) {
      return { data };
    }
    return rejectWithValue(message);
  }
);

const facilitadorGrupoSlice = createSlice({
  name: 'facilitadorGrupo',
  initialState,
  reducers: {
    clearMisGrupos: (state) => {
      state.gruposActivos = [];
      state.gruposFinalizados = [];
      state.statusActivos = 'idle';
      state.statusFinalizados = 'idle';
      state.error = '';
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchMisGruposActivos.pending, (state) => {
        state.statusActivos = 'loading';
      })
      .addCase(fetchMisGruposActivos.fulfilled, (state, action) => {
        state.statusActivos = 'completed';
        state.gruposActivos = Array.isArray(action.payload.data) ? action.payload.data : [];
      })
      .addCase(fetchMisGruposActivos.rejected, (state, action) => {
        state.statusActivos = 'failed';
        state.error = action.payload as string;
      })
      .addCase(fetchMisGruposFinalizados.pending, (state) => {
        state.statusFinalizados = 'loading';
      })
      .addCase(fetchMisGruposFinalizados.fulfilled, (state, action) => {
        state.statusFinalizados = 'completed';
        state.gruposFinalizados = Array.isArray(action.payload.data) ? action.payload.data : [];
      })
      .addCase(fetchMisGruposFinalizados.rejected, (state, action) => {
        state.statusFinalizados = 'failed';
        state.error = action.payload as string;
      });
  },
});

export const selectFacilitadorGruposActivos = (state: RootState) => state.facilitadorGrupo.gruposActivos;
export const selectFacilitadorGruposFinalizados = (state: RootState) => state.facilitadorGrupo.gruposFinalizados;
export const selectFacilitadorGruposActivosStatus = (state: RootState) => state.facilitadorGrupo.statusActivos;
export const selectFacilitadorGruposFinalizadosStatus = (state: RootState) => state.facilitadorGrupo.statusFinalizados;

export const { clearMisGrupos } = facilitadorGrupoSlice.actions;

export default facilitadorGrupoSlice.reducer;
